import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/become_target';

/** 状況 `become_target_elsewhere`（組み立ては `../fx/become_target.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'become_target_elsewhere', role: 'effect', ...spec }, 'become_target_elsewhere_effect.js');
